module.exports = __webpack_public_path__ + "img/logo-grey.d9c9a1a8.svg";